<template>
    <!-- This templates was made by Colorlib (https://colorlib.com) -->
    <div id="err">
      <div class="err">
        <div class="err-5xx">
          <div></div>
          <h1><font-awesome-icon :icon="['fas', 'tools']" /></h1>
        </div>
        <h2>{{ $t('err5xx.title') }}</h2>
        <p>{{ $t('err5xx.text') }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Err5xx'
  };
  </script>
  
  <style lang="css">
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  body {
    padding: 0;
    margin: 0;
    height: 100%;
  }
  
  #err {
    position: relative;
    height: 100vh;
  }
  
  #err .err {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  
  .err {
    max-width: 600px;
    width: 100%;
    text-align: center;
    line-height: 1.4;
  }
  
  .err .err-5xx {
    position: relative;
    width: 180px;
    height: 180px;
    margin: 50px auto 50px;
  }
  
  .err .err-5xx > div:first-child {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #ffa500;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    border: 5px solid #565656;
    border-radius: 5px;
  }
  
  .err .err-5xx > div:first-child:before {
    content: '';
    position: absolute;
    left: -5px;
    right: -5px;
    bottom: -5px;
    top: -5px;
    -webkit-box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.1) inset;
    box-shadow: 0px 0px 0px 5px rgba(0, 0, 0, 0.1) inset;
    border-radius: 5px;
  }
  
  .err .err-5xx h1 {
    font-family: 'Cabin', sans-serif;
    color: #ffffff;
    font-weight: 700;
    margin: 0;
    font-size: 90px;
    position: absolute;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    left: 50%;
    text-align: center;
    line-height: 40px;
  }
  
  .err h2 {
    padding: 0 1rem;
    margin-top: 5rem;
    font-family: 'Cabin', sans-serif;
    font-size: 33px;
    font-weight: 700;
    text-transform: uppercase;
  }
  
  .err p {
    padding: 0 1rem;
    font-family: 'Cabin', sans-serif;
    font-size: 20px;
    color: #696969;
    font-weight: 400;
    text-align: center;
  }
  </style>
  